import PageContainerStyle from "./PageContainer.styles";

const RightBox = ({ children }) => {
  const classes = PageContainerStyle();
  return <div className={`${classes.rightBox} rightsectionWrapper`}>{children}</div>;
};
export default RightBox;
